// @flow
import React, {
  // $FlowFixMe
  useEffect,
  // $FlowFixMe
  useMemo,
  // $FlowFixMe
  useState,
  // $FlowFixMe
  useCallback,
  // $FlowFixMe
  useRef,
  // $FlowFixMe
  Fragment
} from "react";
/* flow-enable */
import { connect, useSelector } from "react-redux";
import { graphql } from "@apollo/client/react/hoc";
import { get, noop, flowRight as compose } from "lodash";
import mediator from "@tvg/mediator";
import tvgConf from "@tvg/conf";
import { useWindowScrollPosition } from "@fdr/custom-hooks/ProgramPage";
import { fixedOffset } from "@fdr/utils/RaceHeaderUtils";
import { onOpenComplianceModal } from "@tvg/sh-lib-account-wallet/src/utils/mobileUtils";
import { isAccountCompliantSelector } from "@tvg/sh-utils/sessionUtils";
import { sendRacePageView } from "@fdr/utils/pageViewGTM";
import {
  showRaceNavigationHeader,
  setRace,
  setPreviousPath,
  setVideoCarouselAction
} from "@fdr/shared-actions/ProgramPageActions";
// $FlowFixMe
import { Navigate } from "react-router-dom";
import withRouter from "@tvg/utils/withCustomRouter";
import { useRequested } from "@tvg/top-pools";
import PGMHeader from "@fdr/program-page-header";
import WagerSelector from "@fdr/program-page-wager-selector";
import RaceCard from "@fdr/racecard";
import { ProgramPageHeaderMask, WagerSelectorMask } from "@fdr/static-ui/Masks";
import RaceHeaderUtils from "@tvg/utils/RaceHeaderUtils";
import BetTicketComp from "@fdr/bet";
import RaceOfficials from "@fdr/race-officials";
import RaceBets from "@fdr/atomic-ui/_organisms/RaceBets";
import RacecardMask from "@fdr/static-ui/Masks/racecard";
import RaceCardSortInfo from "@fdr/atomic-ui/_molecules/RaceCardSort";
import ProgramPageTabs from "@fdr/atomic-ui/_organisms/ProgramPageTabs";
import {
  setBetType,
  setBetState,
  resetSelection,
  setBetConfirmation,
  setWagerTypes
} from "@tvg/shared-actions/BetActions";
import type { NullaryFn, UnaryFn } from "@tvg/types/Functional";
import {
  AWPath,
  openAWPage
} from "@tvg/sh-lib-account-wallet/src/utils/AWPages";
import { getJWPlaylistVideos } from "@fdr/video-builder/src/utils";
import { getDefaultPlaylistSettings } from "@fdr/video-builder/src/selectors";
import { getAccountNumber } from "@urp/store-selectors";
import { differenceInMinutes } from "date-fns";
import { getVideoCarouselSelector } from "./selectors";
import RaceQuery from "./graphql/queries/RaceProgramQuery.graphql";
import RaceSubscription from "./graphql/subscriptions/RaceProgramSubscriptions.graphql";
import WagersSubscription from "./graphql/subscriptions/WagersSubscription.graphql";
import RaceProbablesSubscription from "./graphql/subscriptions/RaceProgramProbablesSubscription.graphql";
import ApolloOptions from "./graphql/options.graph";
import type { Props, GenericTimer } from "./types";
import BetQuery from "./graphql/queries/WagerQuery.graphql";
import BetQueryTotal from "./graphql/queries/WagerQueryTotal.graphql";
import ApolloBetsOptionsWagerTotals from "./graphql/behgOptionsWagerTotals.graph";
import ApolloBetsOptions from "./graphql/behgOptions.graph";

export const onboardingTooltipTimer: GenericTimer = {
  timer: null,
  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  startTimer({ time, fn }) {
    this.clearTimer();
    this.timer = setTimeout(() => {
      fn();
    }, time);
  }
};

export const setTab = (
  tab: string,
  setActiveTab: UnaryFn<string, void>,
  props: Props
) => {
  let isAllowedTab = true;
  if (tab === "Racecard") {
    mediator.base.dispatch({
      type: "RACE_RESULTS_SELECT_TAB",
      payload: {
        tabName: "Racecard",
        raceResults: get(props.race, "status.code") === "RO"
      }
    });
  }

  if (tab === "Bets") {
    if (!props.isUserLogged) {
      mediator.base.dispatch({
        type: "OPEN_LOGIN",
        payload: {
          callback: () => {
            setActiveTab(tab);
          }
        }
      });

      isAllowedTab = false;
    } else if (!props.isAccountCompliant) {
      onOpenComplianceModal();
      isAllowedTab = false;
    }
  }

  if (isAllowedTab) {
    setActiveTab(tab);
  }
};

export const getTabs = (
  currentRace: *,
  activeTab: string,
  setActiveTab: UnaryFn<string, *>,
  props: Props
) => [
  {
    title: "Result",
    tag: {
      isVisible: get(currentRace, "status.code") === "SK",
      text: "PENDING"
    },
    isActive: activeTab === "Result",
    onClick: (tab: string) => {
      setTab(tab, setActiveTab, props);
    }
  },
  {
    title: "Bets",
    counter: get(props.userRaceBets, "length", 0),
    isActive: activeTab === "Bets",
    onClick: (tab: string) => {
      setTab(tab, setActiveTab, props);
    }
  },
  {
    title: "Racecard",
    isActive: activeTab === "Racecard",
    onClick: (tab: string) => {
      setTab(tab, setActiveTab, props);
    }
  }
];

export const emptyMessageGtmCallback = (gtmNavigationData: mixed) => {
  mediator.base.dispatch({
    type: "MYBETS_EMPTY_MESSAGE",
    payload: {
      ...gtmNavigationData
    }
  });
};

export const getVideoFeedback = (props: Props) =>
  RaceHeaderUtils.getVideoFeedback(
    get(props, "race"),
    get(props, "races[0]"),
    get(props, `races[${get(props, "races.length", 1) - 1}]`),
    true
  );

export const renderRacecard = (
  currentRace: *,
  isWagerable: boolean,
  isResulted: boolean,
  props: Props,
  showOnboardingInfo: boolean,
  runnerSelectionCallback: Function
) => {
  const racecard = (
    <RaceCard
      racesData={get(props, "racesData")}
      isLoadingPP={get(props, "isLoading")}
      race={currentRace}
      isWagerable={isWagerable}
      races={get(props, "races")}
      wagerProfile={get(props, "wagerProfile")}
      hasWebSockets={get(props, "hasWebSockets", false)}
      isResulted={isResulted}
      showOnboardingInfo={showOnboardingInfo}
      runnerSelectionCallback={runnerSelectionCallback}
      internationalLabel={get(props, "internationalLabel", "Int'l terms")}
      bettingInterests={get(props, "bettingInterests", [])}
      history={get(props, "history")}
    />
  );

  return racecard;
};

export const renderResultedComponents = (
  activeTab: string,
  currentRace: *,
  isWagerable: boolean,
  props: Props,
  showOnboardingInfo: boolean,
  runnerSelectionCallback: Function
) => {
  switch (activeTab) {
    case "Bets": {
      return (
        <RaceBets
          showRace={false}
          emptyMessageCallback={emptyMessageGtmCallback}
          emptyMessage={{
            body: props.emptyBetsMessage,
            title: "",
            nextRaceGtm: {
              buttonText: "",
              module: "",
              destinationUrl: ""
            },
            allTracksGtm: {
              buttonText: "",
              module: "",
              destinationUrl: ""
            }
          }}
          raceNumber={currentRace.raceNumber}
          bets={props.userRaceBets}
          isFromResultedBetTab
        />
      );
    }
    case "Result": {
      return (
        <RaceOfficials
          hasWebSockets={props.hasWebSockets}
          race={currentRace}
          races={get(props, "races")}
          wagerProfile={get(props, "wagerProfile")}
          wagerType={get(props, "wagerType")}
          isLoading={get(props, "isLoading")}
          showSilks={get(props, "showSilks")}
        />
      );
    }
    default: {
      return renderRacecard(
        currentRace,
        isWagerable,
        true,
        props,
        showOnboardingInfo,
        runnerSelectionCallback
      );
    }
  }
};

export const onAccountBalanceClick = (isAccountCompliant: boolean) => {
  if (!isAccountCompliant) {
    onOpenComplianceModal();
    return;
  }
  openAWPage(AWPath.Deposit);
};

export const renderProgramPage = (
  hasRequested: boolean,
  currentRace: *,
  isWagerable: boolean,
  renderBetTicket: *,
  activeTab: string,
  setActiveTab: UnaryFn<string, *>,
  props: Props,
  showOnboardingInfo: boolean,
  runnerSelectionCallback: Function
) => {
  const videoFeedBack =
    get(props, "trackAbbr") === get(currentRace, "track.trackCode")
      ? getVideoFeedback(props)
      : "NOT_AVAILABLE_NO_REPLAY";

  return (hasRequested && get(props, "accountNumber") !== null) ||
    !!get(props, "race") ? (
    <Fragment>
      <PGMHeader
        prevPath={get(props, "prevPath")}
        isWagerable={isWagerable}
        racesData={get(props, "racesData")}
        races={get(props, "races")}
        numberOfRaces={get(props, "race.track.numberOfRaces")}
        race={currentRace}
        wagerProfile={get(props, "wagerProfile")}
        isRaceNavigationShown={get(props, "isNavigationShown")}
        videoFeedback={videoFeedBack}
        trackAbbr={get(props, "trackAbbr")}
      />
      {isWagerable ? (
        <Fragment>
          <WagerSelector
            isLoadingPP={get(props, "isLoading")}
            race={currentRace}
            wagerProfile={get(props, "wagerProfile")}
            withVideo={get(props, "withVideo")}
            history={get(props, "history")}
          />
          {renderRacecard(
            currentRace,
            isWagerable,
            false,
            props,
            showOnboardingInfo,
            runnerSelectionCallback
          )}
          {get(props, "startBetting") && renderBetTicket()}
        </Fragment>
      ) : (
        <Fragment>
          <ProgramPageTabs
            fixedOffset={fixedOffset(get(props, "withVideo"))}
            tabs={getTabs(currentRace, activeTab, setActiveTab, props)}
            withVideo={get(props, "withVideo")}
          />
          {renderResultedComponents(
            activeTab,
            currentRace,
            isWagerable,
            props,
            showOnboardingInfo,
            runnerSelectionCallback
          )}
        </Fragment>
      )}
    </Fragment>
  ) : (
    <Fragment>
      <ProgramPageHeaderMask />
      <WagerSelectorMask />
      <RaceCardSortInfo />
      <RacecardMask />
    </Fragment>
  );
};

export const buildUniqueSubscription = (
  query: *,
  props: Props,
  hasSubscription: boolean,
  setHasSubscription: UnaryFn<?NullaryFn<void>, void>
) => {
  if (props.subscribeToMore && props.races && !hasSubscription) {
    const tvgRaceIds = props.races.map((race) => get(race, "tvgRaceId"));

    if (typeof hasSubscription === "function") {
      hasSubscription();
    }

    const unsubscribe = props.subscribeToMore({
      document: query,
      variables: {
        trackAbbr: get(props, "trackAbbr", "").toUpperCase(),
        wagerProfile: get(props, "wagerProfile", ""),
        raceNumber: get(props, "raceNumber"),
        tvgRaceIds,
        ...tvgConf().graphContext()
      }
    });
    setHasSubscription(() => unsubscribe);
  }
};

export const buildUpdateSubscription = (
  query: *,
  props: Props,
  hasSubscription: boolean,
  setHasSubscription: UnaryFn<?NullaryFn<void>, void>
) => {
  if (props.subscribeToMore && props.races) {
    const tvgRaceIds = props.races.map((race) => get(race, "tvgRaceId"));

    if (typeof hasSubscription === "function") {
      hasSubscription();
    }

    const unsubscribe = props.subscribeToMore({
      document: RaceSubscription,
      variables: {
        trackAbbr: get(props, "trackAbbr", "").toUpperCase(),
        wagerProfile: get(props, "wagerProfile", ""),
        raceNumber: get(props, "raceNumber"),
        tvgRaceIds,
        ...tvgConf().graphContext()
      }
    });
    setHasSubscription(() => unsubscribe);
  } else {
    if (typeof hasSubscription === "function") {
      hasSubscription();
    }
    setHasSubscription(null);
  }
};

export const ProgramPage = (props: Props) => {
  const [currentRace, setCurrentRace] = useState({ raceNumber: 0 });
  const [firstLoad, setFirstLoad] = useState(true);
  const [isWagerable, setWagerableState] = useState(true);
  const [activeTab, setActiveTab] = useState("Result");
  const hasRequested = useRequested(props.isLoading);
  const scrollPosition = useWindowScrollPosition(100);
  const [hasRaceSubscription, setHasRaceSubscription] = useState(null);
  const [hasRaceBetSubscription, sethasRaceBetRaceSubscription] =
    useState(null);
  const [hasProbablesSubscription, setHasProbablesSubscription] =
    useState(null);

  const isMultiLeg = props.bettingInterests.length > 1;

  const [onboardingTooltipShow, setOnboardingTooltipShow] =
    useState(isMultiLeg);

  const [onboardingTooltipDismissed, setOnboardingTooltipDismissed] =
    useState(false);

  const [hasClickedSelections, setHasClickedSelections] = useState(false);

  const [hasSwipped, setHasSwipped] = useState(false);

  const prevRaceRef = useRef(null);

  const { playerScript, licenseKey } = useSelector(getDefaultPlaylistSettings);

  useEffect(() => {
    if (props.betLeg > 0) {
      setHasSwipped(true);
    }
  }, [props.betLeg]);

  useEffect(() => {
    setOnboardingTooltipDismissed(false);
    setHasSwipped(false);
    setHasClickedSelections(false);
  }, [
    props.accountNumber,
    props.raceNumber,
    props.trackAbbr,
    get(props, "wagerType.type.id")
  ]);

  useEffect(() => {
    if (!isWagerable) {
      props.dispatch(setBetState("none"));
      props.dispatch(resetSelection());

      // $FlowFixMe
      const modalOpened = document.body.classList.contains("modal");
      if (modalOpened && props.showBetConfirmation) {
        props.dispatch(setBetConfirmation(false));
        // $FlowFixMe
        document.body.classList.remove("modal");
      }
    }
  }, [isWagerable]);

  useEffect(() => {
    if (
      !onboardingTooltipDismissed &&
      props.showOnboarding &&
      isMultiLeg &&
      props.betLeg !== 0
    ) {
      setOnboardingTooltipShow(true);
    } else {
      onboardingTooltipTimer.clearTimer();
      setOnboardingTooltipShow(false);
    }
  }, [props.showOnboarding, props.betLeg]);

  // constructor like
  useEffect(() => {
    props.dispatch(setBetState("none"));
    props.dispatch(resetSelection());
    props.dispatch(setBetConfirmation(false));

    const { lastFetchDate } = props.videoCarousel;

    if (!lastFetchDate || differenceInMinutes(new Date(), lastFetchDate) > 60) {
      getJWPlaylistVideos(
        props.programPageVideoPlaylistUrl,
        {
          playerScript,
          licenseKey
        },
        true
      ).then((res) =>
        props.dispatch(
          setVideoCarouselAction({
            raceId: res.raceId,
            raceDate: res.raceDate,
            videoCards: res.playlist,
            title: res.title,
            lastFetchDate: new Date()
          })
        )
      );
    }

    return () => {
      props.dispatch(setRace({}));
      props.dispatch(setBetType(null));
    };
  }, []);

  useEffect(() => {
    if (hasRequested) {
      const maxScrollPosition = 75;
      if (firstLoad) {
        props.dispatch(showRaceNavigationHeader(false));
        setFirstLoad(false);
      } else if (
        scrollPosition > maxScrollPosition &&
        !props.isNavigationShown
      ) {
        props.dispatch(showRaceNavigationHeader(true));
      } else if (
        scrollPosition <= maxScrollPosition &&
        props.isNavigationShown
      ) {
        props.dispatch(showRaceNavigationHeader(false));
      }
    }
  }, [scrollPosition, hasRequested]);

  useEffect(() => {
    buildUpdateSubscription(
      RaceSubscription,
      props,
      hasRaceSubscription,
      setHasRaceSubscription
    );

    buildUpdateSubscription(
      RaceProbablesSubscription,
      props,
      hasProbablesSubscription,
      setHasProbablesSubscription
    );

    prevRaceRef.current = null;
  }, [props.raceNumber]);

  useEffect(() => {
    if (prevRaceRef.current === null && props.race !== null) {
      sendRacePageView(props);
    }
    prevRaceRef.current = props.race;
  }, [JSON.stringify(props.race)]);

  useEffect(() => {
    buildUniqueSubscription(
      RaceSubscription,
      props,
      hasRaceSubscription,
      setHasRaceSubscription
    );

    buildUniqueSubscription(
      RaceProbablesSubscription,
      props,
      hasProbablesSubscription,
      setHasProbablesSubscription
    );
  }, [JSON.stringify(props.races)]);

  useEffect(() => {
    const isRaceClosed = ["SK", "RO", "C"].includes(
      get(props, "race.status.code")
    );
    if (typeof hasRaceBetSubscription === "function") {
      hasRaceBetSubscription();
    }
    if (isRaceClosed && props.isUserLogged && props.subscribeToMoreBets) {
      const unsubscribe = props.subscribeToMoreBets({
        document: WagersSubscription,
        variables: {
          trackCode: get(props, "trackAbbr", "").toUpperCase(),
          accountId: get(props, "accountNumber", ""),
          raceNumber: get(props, "raceNumber")
        }
      });
      sethasRaceBetRaceSubscription(() => unsubscribe);
    } else {
      sethasRaceBetRaceSubscription(null);
    }
  }, [props.raceNumber, props.isUserLogged, get(props, "race.status.code")]);

  useEffect(() => {
    if (props.race && props.raceNumber === props.race.raceNumber) {
      setCurrentRace({
        ...props.race,
        bettingInterests: props.bettingInterests
      });

      props.dispatch(
        setRace({
          ...props.race,
          bettingInterests: props.bettingInterests
        })
      );
    }
  }, [JSON.stringify(props.race), JSON.stringify(props.bettingInterests)]);

  useEffect(() => {
    if (!props.prevPath.includes("/racetracks") && props.prevPath !== " ") {
      props.dispatch(setPreviousPath(props.prevPath));
    }
  }, [props.prevPath]);

  useEffect(() => {
    const wagerableState =
      get(props, "race.status.code") !== "SK" &&
      get(props, "race.status.code") !== "RO";
    setWagerableState(wagerableState);
    setCurrentRace({
      ...props.race,
      bettingInterests: props.bettingInterests
    });

    props.dispatch(
      setRace({
        ...props.race,
        bettingInterests: props.bettingInterests
      })
    );
  }, [get(props, "race.status.code")]);

  useEffect(() => {
    setActiveTab("Result");
    // TO DO - try to reproduce QFD-535 - https://fanduel.atlassian.net/browse/QFD-535
    // props.dispatch(setBetType(null));
    // props.dispatch(setWagerTypes([]));
  }, [get(props, "race.id")]);

  const renderBetTicket = useCallback(() => {
    if (onboardingTooltipShow) {
      onboardingTooltipTimer.startTimer({
        time: 5000,
        fn: () => {
          setOnboardingTooltipShow(false);
          setOnboardingTooltipDismissed(true);
        }
      });
    }

    return (
      <BetTicketComp
        key="raceCardBetTicket"
        isVisible={props.startBetting}
        betSelections={props.betSelections}
        betAmount={+props.betAmount}
        isVideoShown={false}
        isMultiLeg={isMultiLeg}
        bettingInterests={currentRace.bettingInterests}
        race={currentRace}
        races={get(props, "races")}
        wagerType={get(props, "wagerType")}
        probables={get(currentRace, "probables")}
        columnLayout="single"
        showBetConfirmation={props.showBetConfirmation}
        scratchedSelections={props.scratchedSelections}
        talentPick={null}
        pickEditButton={false}
        onCloseOnboardingTooltip={() => {
          onboardingTooltipTimer.clearTimer();
          setOnboardingTooltipShow(false);
          setOnboardingTooltipDismissed(true);
        }}
        onboardingTooltipShow={onboardingTooltipShow}
        watchButtonBetPlacedToggle={props.watchButtonBetPlacedToggle}
        history={get(props, "history")}
        gasClient={props.gasClient}
      />
    );
  }, [
    props.startBetting,
    JSON.stringify(props.betSelections),
    props.showBetConfirmation,
    props.betAmount,
    JSON.stringify(get(currentRace, "probables")),
    JSON.stringify(props.wagerType),
    JSON.stringify(props.scratchedSelections),
    JSON.stringify(currentRace),
    onboardingTooltipShow,
    props.showOnboarding
  ]);

  return useMemo(
    () =>
      props.race || props.isLoading || props.accountNumber === null ? (
        renderProgramPage(
          hasRequested,
          currentRace,
          isWagerable,
          renderBetTicket,
          activeTab,
          setActiveTab,
          props,
          (props.showOnboarding && !(hasClickedSelections && hasSwipped)) ||
            !props.isAccountCompliant,
          () => {
            setHasClickedSelections(true);
          }
        )
      ) : (
        <Navigate to="/" />
      ),
    [
      hasRequested,
      activeTab,
      props.raceNumber,
      props.accountNumber,
      props.isUserLogged,
      props.withVideo,
      props.startBetting,
      props.showBetConfirmation,
      props.betAmount,
      props.isLoading,
      get(props, "wagerType.type.id"),
      JSON.stringify(get(currentRace, "probables")),
      JSON.stringify(props.racesData),
      JSON.stringify(props.betSelections),
      JSON.stringify(props.scratchedSelections),
      JSON.stringify(props.userRaceBets),
      JSON.stringify(props.race),
      JSON.stringify(currentRace),
      JSON.stringify(props.bettingInterests),
      onboardingTooltipShow,
      hasClickedSelections,
      hasSwipped,
      props.showOnboarding
    ]
  );
};

ProgramPage.defaultProps = {
  isUserLogged: false,
  isLoading: true,
  race: { mtp: 0 },
  wagerProfile: "FDR-Generic",
  trackAbbr: "",
  raceNumber: "0",
  dispatch: noop,
  isNavigationShown: false,
  subscribeToMore: noop,
  prevPath: "",
  wagerType: null,
  withVideo: false,
  startBetting: false,
  betAmount: 0,
  betState: false,
  betSelections: [[]],
  betLeg: 0,
  showBetConfirmation: false,
  accountNumber: "",
  hasWebSockets: false,
  scratchedSelections: [[]],
  userRaceBets: [],
  racesData: [],
  bettingInterests: [],
  emptyBetsMessage: "",
  subscribeToMoreBets: noop,
  behgClient: null,
  gasClient: null,
  isLoadingOnboarding: true,
  showOnboarding: false,
  showSilks: false,
  watchButtonBetPlacedToggle: false,
  hasMultiLegWagers: undefined,
  prevRaceNumber: ""
};

export default withRouter(
  connect((store) => ({
    emptyBetsMessage: get(store, "capi.messages.emptyBetsMessage"),
    watchButtonBetPlacedToggle: get(
      store,
      "capi.featureToggles.watchButtonBetPlaced",
      false
    ),
    bettingInterests: get(
      store,
      "RaceProgram.currentRace.bettingInterests",
      []
    ),
    isNavigationShown: get(
      store,
      "RaceProgram.showHeaderRaceNavigation",
      false
    ),
    accountNumber: getAccountNumber(store),
    racingId: get(store, "userData.user.fdUserId"),
    isUserLogged: get(store, "userData.logged"),
    isAccountCompliant: isAccountCompliantSelector(store),
    withVideo: get(store, "RaceProgramVideo.show", false),
    wagerType: get(store, "RaceProgram.betType", 0),
    startBetting: get(store, "RaceProgram.startBetting"),
    betAmount: get(store, "RaceProgram.betAmount"),
    betState: get(store, "RaceProgram.betState"),
    betSelections: get(store, "RaceProgram.betSelections"),
    betLeg: get(store, "RaceProgram.betLeg"),
    showBetConfirmation: get(store, "RaceProgram.showBetConfirmation"),
    scratchedSelections: get(store, "RaceProgram.scratchedSelections"),
    showSilks: get(store, "capi.featureToggles.showSilks", false),
    internationalLabel: get(
      store,
      "capi.messages.descriptionsWinBetGroup.INT",
      ""
    ),
    pickBetsOnboardingToggle: get(
      store,
      "capi.featureToggles.pickBetsOnboarding",
      false
    ),
    showOnboarding: !get(store, "RaceProgram.hasMultiLegWagers", true),
    hasMultiLegWagers: get(store, "RaceProgram.hasMultiLegWagers"),
    videoCarousel: getVideoCarouselSelector(store),
    programPageVideoPlaylistUrl: get(
      store,
      "capi.messages.programPageVideoPlaylistUrl"
    )
  }))(
    compose(
      graphql(BetQueryTotal, ApolloBetsOptionsWagerTotals),
      graphql(BetQuery, ApolloBetsOptions),
      graphql(RaceQuery, ApolloOptions)
    )(ProgramPage)
  )
);
